var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44615 12.0836C7.37175 11.7952 7.22143 11.532 7.01083 11.3214C6.80023 11.1108 6.53704 10.9605 6.24865 10.8861L1.13615 9.56775C1.04892 9.54299 0.972155 9.49046 0.917492 9.41812C0.862828 9.34578 0.833252 9.25758 0.833252 9.16691C0.833252 9.07624 0.862828 8.98805 0.917492 8.91571C0.972155 8.84337 1.04892 8.79084 1.13615 8.76608L6.24865 7.44691C6.53694 7.37259 6.80006 7.22239 7.01065 7.01195C7.22124 6.8015 7.37162 6.53849 7.44615 6.25025L8.76448 1.13775C8.78899 1.05018 8.84147 0.973033 8.91391 0.918077C8.98636 0.863121 9.0748 0.833374 9.16573 0.833374C9.25666 0.833374 9.3451 0.863121 9.41755 0.918077C9.48999 0.973033 9.54247 1.05018 9.56698 1.13775L10.8845 6.25025C10.9589 6.53864 11.1092 6.80183 11.3198 7.01243C11.5304 7.22303 11.7936 7.37335 12.082 7.44775L17.1945 8.76525C17.2824 8.7895 17.3599 8.84192 17.4152 8.91448C17.4704 8.98703 17.5004 9.07571 17.5004 9.16691C17.5004 9.25811 17.4704 9.34679 17.4152 9.41935C17.3599 9.49191 17.2824 9.54433 17.1945 9.56858L12.082 10.8861C11.7936 10.9605 11.5304 11.1108 11.3198 11.3214C11.1092 11.532 10.9589 11.7952 10.8845 12.0836L9.56615 17.1961C9.54164 17.2836 9.48916 17.3608 9.41671 17.4158C9.34427 17.4707 9.25583 17.5005 9.1649 17.5005C9.07397 17.5005 8.98553 17.4707 8.91308 17.4158C8.84063 17.3608 8.78815 17.2836 8.76365 17.1961L7.44615 12.0836Z",
    stroke: "#00786F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.bb593e79fa874fb5887e0d9795b7fb9c.svg";
export { ForwardRef as ReactComponent };